import React from 'react';
import { Button } from '@material-ui/core';
import { AddCircleOutline } from '@mui/icons-material';
import { useHistory, useRouteMatch } from 'react-router';

export const AddAffiliationButton = (): JSX.Element => {
  const history = useHistory();
  const match = useRouteMatch();
  return (
    <Button
      onClick={(): void => history.push(`${match.url}/affiliations/new`)}
      color="primary"
      variant="outlined"
      size="large"
      endIcon={<AddCircleOutline />}
    >
      Add new affiliation
    </Button>
  );
};
